import React, { Component } from "react";
import PropTypes from "prop-types";
// import Avatar from "material-ui/Avatar";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import Paper from "material-ui/Paper";
import { Card, CardHeader, CardText } from "material-ui/Card";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { BlockCounter, Counter, Alignment, TextInput } from "./components";
import { UploadAvatar } from "../../../components";
import { DivHeaderActions, DivTitle } from "./styled";

const defaultHref = {
  url: "",
  target: "",
  isCollection: false,
  collection: 0
};

class AvatarView extends Component {
  constructor(props) {
    super(props);
    const { containerPadding, align, size, url, href } = props.data.values;
    this.state = {
      isEditMode: false,
      expanded: true,
      align: align,
      url: url,
      containerPadding: containerPadding,
      size: size,
      href: href || defaultHref
    };
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.align = this.state.align;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.size = this.state.size;
    newData.values.url = this.state.url;
    newData.values.href = this.state.href;
    this.props.onUpdateData(newData);
  };

  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };

  onChangeAlign = value => {
    this.setState({ align: value });
  };

  onUpdateHrefUrl = value => {
    let newHref = this.state.href;
    newHref.url = value;

    this.setState({
      href: newHref
    });
  };
  onChangeTarget = (event, index, value) => {
    const newValue = value === "_blank" ? value : "";
    let newHref = this.state.href;
    newHref.target = newValue;
    this.setState({
      href: newHref
    });
  };
  onUpdateAvatarSize = value => {
    this.setState({ size: value });
  };
  onUpdateUrl = value => {
    this.setState({ url: value });
  };
  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.align = this.state.align;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.size = this.state.size;
    newData.values.url = this.state.url;
    newData.values.href = this.state.href;
    localStorage.setItem("AvatarView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const avatarContent = JSON.parse(localStorage.getItem("AvatarView"));
    if (avatarContent) {
      const { containerPadding, align, size, url, href } = avatarContent;
      this.setState({
        align: align,
        url: url,
        containerPadding: containerPadding,
        size: size,
        href: href || defaultHref
      });
    }
  };
  render() {
    const { type } = this.props.data.values;
    const { target } = this.state.href;
    const valueTarget = target === "_blank" ? target : "same";
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Avatar"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              expandable={true}
              style={{ overflowY: "scroll", height: 500 }}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Upload Avatar</DivTitle>
                <UploadAvatar
                  type={type}
                  imageUrl={this.state.url}
                  onUpdateUrl={value => this.onUpdateUrl(value)}
                  title="Avatar"
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={containerPadding =>
                    this.onUpdatePadding(containerPadding)
                  }
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Avatar Size</DivTitle>
                <Counter
                  onSetValue={value => this.onUpdateAvatarSize(value)}
                  value={this.state.size}
                  interval={1}
                  subtitle="px"
                />
              </Paper>

              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Alignment</DivTitle>
                <Alignment
                  value={this.state.align}
                  onChange={value => this.onChangeAlign(value)}
                  title=""
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Action</DivTitle>
                <SelectField
                  floatingLabelText="Target"
                  onChange={(event, index, value) =>
                    this.onChangeTarget(event, index, value)
                  }
                  value={valueTarget}
                  autoWidth={true}
                  name="target href"
                >
                  <MenuItem value={"same"} primaryText="Same Page" />
                  <MenuItem value={"_blank"} primaryText="New Page" />
                </SelectField>
                <TextInput
                  value={this.state.href.url}
                  onChange={value => this.onUpdateHrefUrl(value)}
                  name="HrefUrl"
                  title="Url"
                  fullWidth={true}
                />
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  customWidth: {
    width: 150
  },
  block: {
    maxWidth: 250
  },
  radioButton: {
    width: 60
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  }
};

AvatarView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

AvatarView.defaultProps = {
  data: {}
};
export default AvatarView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/AvatarView.js